import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import filter from 'ramda/src/filter';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import Rating from '@components/@core/Rating';
import AppActions from '~/actions/app';
import { ToDoTypes } from '~/services/config';

const PerformanceReviews = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const users = useSelector((state) => state.app.users);
    const reports = useSelector((state) => state.manage.managerDashboard);
    const { average_reviews, scorecards, task_commitments, training_commitments, top_users } = reports.performance;
    const disabled = filter((e) => e !== 'scorecards', ToDoTypes);

    const handleModal = () => {
        const payload = { type: 'Assign ToDo', data: { before: { disabled } } };
        dispatch(AppActions.modalRequest(payload));
    };

    return (
        <div className="card mb-3 me-3 custom-width">
            <p className="dsl-b22 bold">Scorecard Reviews</p>
            <div className="d-flex">
                <div className="performance-card d-flex-3 me-3 py-2 px-1">
                    <p className="dsl-m12 text-400 mb-0">Employees with</p>
                    <p className="dsl-m12 text-400 mb-2">Scorecards</p>
                    <p className="dsl-b16 text-400 mb-0">{scorecards}</p>
                </div>
                <div className="performance-card d-flex-4 me-3 py-2 px-1">
                    <p className="dsl-m12 text-400 mb-0">Average</p>
                    <p className="dsl-m12 text-400 mb-2">Reviews</p>
                    <div className="d-flex align-items-center score-star">
                        <Rating className="ml-2" score={average_reviews} />
                    </div>
                </div>
                <div className="performance-card d-flex-3 py-2 px-1">
                    <p className="dsl-m12 text-400 mb-0">Commitments</p>
                    <p className="dsl-m12 text-400 mb-2">Made</p>
                    <p className="dsl-b16 text-400 mb-0">{task_commitments}</p>
                </div>
            </div>
            <p className="dsl-b18 bold mt-4">Top Reviews</p>
            <div className="px-0 px-md-3">
                <div className="d-flex pb-3 border-bottom">
                    <span className="dsl-m12 text-400 d-flex-4">Employee</span>
                    <span className="dsl-m12 text-400 d-flex-1 justify-end">Score</span>
                    <span className="dsl-m12 text-400 d-flex-3 ms-5 ms-lg-3">Stars</span>
                </div>
                {top_users.length > 0 ? (
                    top_users.map((item, index) => {
                        const user = find(propEq('id', item.user.id), users);
                        const fullName = item.user.profile.first_name + ' ' + item.user.profile.last_name;
                        return (
                            <div className="d-flex align-items-center mt-3" key={`pr${index}`}>
                                <div className="d-flex d-flex-4 align-items-center">
                                    <Avatar name={fullName} url={user?.avatar || item.user.profile.avatar} />
                                    <span className="dsl-b16 ms-3">{fullName}</span>
                                </div>
                                <div className="d-flex-1 justify-end">
                                    <span className="dsl-b16 text-400">{item.stars}</span>
                                </div>
                                <div className="d-flex d-flex-3 ms-5 ms-lg-3 score-hide">
                                    <Rating className="ml-2" score={item.stars} />
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <p className="dsl-m12 text-center mt-3">No top reviews</p>
                )}
            </div>
            <div className="justify-end mt-3">
                <Button className="text-400 me-2" type="low" name="ASSIGN SCORECARD" onClick={handleModal} />
                <Button className="text-400" type="medium" name="PERFORMANCE REPORT" onClick={() => navigate('/hcm/report-performance')} />
            </div>
        </div>
    );
};

export default memo(PerformanceReviews);
